import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "permission" }
const _hoisted_2 = { class: "permission-body" }
const _hoisted_3 = { class: "with-margin" }
const _hoisted_4 = { class: "with-top-margin" }
const _hoisted_5 = { class: "with-top-margin" }
const _hoisted_6 = { class: "with-top-margin" }
const _hoisted_7 = { class: "with-top-margin" }
const _hoisted_8 = { class: "with-top-margin" }
const _hoisted_9 = { class: "with-margin" }
const _hoisted_10 = { class: "permission-footer" }
const _hoisted_11 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_12 = {
  class: "modal",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_13 = { class: "modal-body" }
const _hoisted_14 = { class: "modal-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('permission_01_01')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('permission_01_02')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('permission_01_03')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('permission_01_04')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('permission_01_05')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('permission_01_06')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('permission_01_07')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('permission_01_08')), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('permission_01_09')), 1),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('permission_01_10')), 1),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('permission_01_11')), 1),
      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('permission_01_12')), 1),
      _createVNode(_component_Button, {
        class: "button",
        color: '#e6e6e6',
        textColor: '#535353',
        size: 'small',
        text: _ctx.$t('stopSurvey'),
        onClick: _ctx.gotoOptout
      }, null, 8, ["text", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_Checkbox, {
        class: "checkbox",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeValue($event))),
        label: _ctx.$t('confirmation'),
        value: _ctx.checkbox
      }, null, 8, ["label", "value"]),
      _createVNode(_component_Button, {
        class: "button",
        disabled: !_ctx.checkbox,
        size: 'large',
        text: _ctx.$t('accept'),
        onClick: _ctx.gotoQ1
      }, null, 8, ["disabled", "text", "onClick"])
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('stopQuestionnaire')), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "button",
                class: "modal-action",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal = false))
              }, _toDisplayString(_ctx.$t('no')), 1),
              _createElementVNode("button", {
                type: "button",
                class: "modal-action",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goBack()))
              }, _toDisplayString(_ctx.$t('yes')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}